export default {"src":"/_next/static/media/users-1-outline.0c9108d3.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};